export default function openingTimesService($http, RESOURCES) {
  var openingTimesSegment = '/portal_times';

  function getOpeningTimes(merchantId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + openingTimesSegment).then(function(res) {
      return res.data.openingScheduleChunkList;
    });
  }

  function updateOpeningTimes(merchantId, data) {
    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + openingTimesSegment, data);
  }

  return { getOpeningTimes: getOpeningTimes, updateOpeningTimes: updateOpeningTimes };
}



// WEBPACK FOOTER //
// ./src/app/merchants/opening-times/opening-times.service.js